import { shouldShowFleetAssistantTooltip } from '@common/login/selectors';
import FleetAssistantOnBoarding from '@features/fleetAssistant/FleetAssistantOnBoarding/FleetAssistantOnBoarding';
import { getFleetFlagFromLocalStorage, saveFleetFlagToLocalStorage } from '@features/ui/utils';
import { useState } from 'react';
import { connect } from 'react-redux';

import { State } from '../../../setup/types';

export const onboardingFlagKey = 'hasSeenFleetAssistantWelcomeOnboarding';
const hasSeenOnboarding = !getFleetFlagFromLocalStorage(onboardingFlagKey);

interface FleetAssistantWelcomeProps {
    showTooltip: boolean;
}

const FleetAssistantWelcome = ({ showTooltip }: FleetAssistantWelcomeProps) => {
    const [showOnboarding, toggleOnboarding] = useState<boolean>(hasSeenOnboarding);

    const handleOnBoardingClick = () => {
        if (showOnboarding) {
            toggleOnboarding(!showOnboarding);
            saveFleetFlagToLocalStorage(onboardingFlagKey);
        }
    };

    const onOnboardingText = {
        header: 'fleetAssistant.onboarding.welcome.header',
        body: 'fleetAssistant.onboarding.welcome.body',
    };

    return (
        <FleetAssistantOnBoarding
            showOnboarding={showTooltip && showOnboarding}
            showIconOnboarding={false}
            onOnboardingText={onOnboardingText}
            handleOnBoardingClick={handleOnBoardingClick}
        />
    );
};

const mapStateToProps = (state: State) => ({
    showTooltip: shouldShowFleetAssistantTooltip(state),
});

export default connect(mapStateToProps)(FleetAssistantWelcome);
